import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_CLIENTNOTES_FAILURE,
  FETCH_CLIENTNOTES_REQUEST,
  FETCH_CLIENTNOTES_SUCCESS
} from "../types";

const fetchClientNotes = factoringId => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(FETCH_CLIENTNOTES_REQUEST)());
    const { results = [] } = await api.factoring.getNotesTimeline(factoringId);
    const data = normalize(results, [schema.clientNote]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_CLIENTNOTES_SUCCESS)({
        [factoringId]: data.result
      })
    );
    return results;
  } catch (err) {
    dispatch(createAction(FETCH_CLIENTNOTES_FAILURE)(err));
    throw err;
  }
};

export default fetchClientNotes;
